
const config = {
  baseUrl: "/",
  // serverPath: "http://localhost:8000/api/",

  // Live Server
  // serverPath: "https://dev.propertynu.com/api/",
  // imageUrl: "https://dev.propertynu.com/media/",

  serverPath: "https://propertynu.com/api/",
  imageUrl: "https://propertynu.com/media/",

  // DO NOT CHANGE //
  REACT_APP_FB_APP_ID: process.env.REACT_APP_FB_APP_ID,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  stripePrivateKey: "",
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  fygaroJWTEncryptionKey: process.env.REACT_APP_FYGARO_JWT_ENCRYPTION_KEY,
  REACT_APP_RATE_EXCHANGE_API_KEY: process.env.REACT_APP_RATE_EXCHANGE_API_KEY,

  //----------------|| ZENTRUMHUB ||----------------//
  
  hotelUrl: process.env.REACT_APP_DEMO_HOTEL_URL,
  contentUrl: process.env.REACT_APP_DEMO_CONTENT_URL,
  apiKey: process.env.REACT_APP_API_KEY,
  accountId: process.env.REACT_APP_ACCOUNT_ID,
  channelId: process.env.REACT_APP_CHANNEL_ID,
  autosuggestUrl: process.env.REACT_APP_AUTOSUGGEST_URL,
};
export default config;
